import Classes from 'classnames';
import {createMomentDate} from "../src/core/gd/lib/moment-date";
import React from 'react';
import moment from 'moment'
import {extendMoment} from "moment-range";

// we need it for initialization
// @ts-ignore
const momentRange = extendMoment(moment);

export default function initGlobalVars() {

    // console.log("initGlobalVars()")

    window.Moment       = moment; // make moment global - but this is wrong as uppercase = class not func
    window.moment       = moment; // make moment global

    // window.momentRange  = momentRange; // make momentRange global

    // !!! THIS IS a function to create MomentDate objects
    // DO NOT USE IT (!) use lower case momentDate() !!!!
    // window.MomentDate   = MomentDate; // make moment global
    window.MomentDate   = createMomentDate; // make moment global
    window.momentDate   = createMomentDate; // make moment global

    // @ts-ignore
    window.$ = global.jQuery = require("jquery");

    window.Classes      = Classes;
    window.React        = React;

    window.gdEpicFail   = require('../src/core/gd-screens/epic-fail/epic-fail');
}